<div class="container">
	<div class="modal-header">
		<h4 class="modal-title fw-bold">
			<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.location.title">Filter by Location</span>
		</h4>
		<button (click)="dismiss()" aria-hidden="true" class="btn-close" data-bs-dismiss="modal"
				type="button">
		</button>
	</div>
	<div class="modal-body">
		<div class="col-sm-6">
			<div class="input-group mb-3">
				<span class="input-group-text" id="filter-traits">
					<i class="fa fa-search"></i>
				</span>
				<input [(ngModel)]="textFilter" [placeholder]="traitFilterPlaceHolder" class="form-control"
					   id="textSearch" name="textSearch" type="text">
				<button (click)="textFilter=''" *ngIf="textFilter" aria-label="Clear" class="btn btn-outline-secondary">
					<i class="fa fa-times"></i>
				</button>
			</div>
		</div>
		<div class="row mt-2 mb-2">
			<div class="col-8">
				<div class="mb-3 d-flex align-items-center">
					<jhi-item-count [itemsPerPage]="countLeafLocations(locations)" [page]="1" [total]="countLeafLocations(locations)"></jhi-item-count>
                    <div class="p-2">
                        <span jhiTranslate="common.selected">Selected:</span>
                        <span class="fw-bold pl-2">
                            {{ countSelectedLocations(locations) }}
                        </span>
                    </div>
					<span *ngIf="isLoading" class="throbber ml-2"></span>
				</div>
			</div>
		</div>
		<div class="table-responsive custom-scroll-style" style="height: 260px; overflow: auto">
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th style="width: 50px;">
						<input (change)="toggleAll($event)" [(ngModel)]="allSelected" type="checkbox">
					</th>
					<th><span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.location.table.header.locations"></span></th>
					<th><span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.location.table.header.no.of.environments"></span></th>
				</tr>
				</thead>
				<tbody *ngIf="locations?.length else nodata">
				<tr *ngFor="let loc of visibleLocations" [ngClass]="getRowClass(loc)">
					<td>
						<input (click)="onLocationClick($event, loc)" [(ngModel)]="loc.selected" type="checkbox">
					</td>
					<td>
						<div [style.padding-left.px]="loc.level * 20">
							<span (click)="toggleCollapse(loc)" *ngIf="loc.locations?.length" style="cursor: pointer;">
								<i [ngClass]="loc.collapsed ? 'fa-caret-right' : 'fa-caret-down'" class="fa"></i>
							</span>
							<span *ngIf="!loc.locations?.length" class="ml-3"></span>
							{{ loc.locationName }}
						</div>
					</td>
					<td>{{ loc.totalEnvironments }}</td>
				</tr>
				</tbody>
			</table>
			<ng-template #nodata>
				<tbody>
				<tr>
					<td class="no-records" colspan="4" jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</ng-template>
		</div>
	</div>
	<div class="modal-footer">
		<div class="col-md-12 d-flex justify-content-center">
			<button (click)="apply()" [disabled]="!hasLocationSelected()" class="btn btn-primary ms-2" type="button">
				<span jhiTranslate="apply"></span>
			</button>
			<button (click)="reset()" class="btn btn-secondary ms-2" type="button">
				<span jhiTranslate="reset"></span></button>
		</div>
	</div>
</div>
